import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/projets",
    meta: {
      title: "Paul Jobard / Réalisation",
      key: 0
    }
  },
  {
    path: "/projets",
    component: () => import("../views/projets.vue"),
    meta: {
      title: "Paul Jobard ➡ Projets UX/UI Design",
      key: 1
    }
  },
  {
    path: "/expertise",
    component: () => import("../views/expertise.vue"),
    meta: {
      title: "Paul Jobard ➡ Expertise UX/UI Design",
      key: 2
    }
  },
  {
    path: "/contact",
    component: () => import("../views/contact.vue"),
    meta: {
      title: "Paul Jobard ➡ paul@jobard.design",
      key: 3
    }
  },
  //PROJETS
  {
    path: "/fedexsoundtrack",
    component: () => import("../views/design.vue"),
    meta: {
      title: "Paul Jobard ➡ FedEx Soundtrack",
      key: 4
    },
    props: {
      h1: "Lead UX Designer <b>&</b> Créatif Assistant <b>pour</b> FedEx",
      h2: {
        job: "(<b>UX</b>&<b>Créa</b>)",
        feat: "Mediamonks",
        name: "<b>FedEx Soundtrack</b>",
        descr: "(Campagne web, USA)"
      },
      color: {
        backgroundColor: "#130029"
      },
      intro:
        "Transforme ton code de Suivi de Livraison FedEx en un son unique traduit visuellement dans un environnement webGL, et découvre l'incroyable infrastructure cachée derrière leurs services. Dans cette expérience de Suivi de Livraison complètement réimaginée, vous pouvez insérer votre Tracking Code FedEx et découvrir une bande son unique. L'expérience affiche les étapes et les informations de votre livraison et génére une musique customisée selon ses variables. Alimenté par 600+ samples audio, l'algorithme accoustique prend en considération absolument tous; de la météo en temps réel, la localisation, l'itinéraire, au poids du colis, ses caractéristiques et son mode de livraison.",
      imgs: {
        0: {
          name: "fedex-img1",
          ext: "png"
        },
        1: {
          name: "fedex-img2",
          ext: "png"
        },
        2: {
          name: "fedex-img3",
          ext: "png"
        },
        3: {
          name: "fedex-img4",
          ext: "png"
        },
        4: {
          name: "fedex-img5",
          ext: "png"
        },
        5: {
          name: "fedex-img6",
          ext: "png"
        },
        6: {
          name: "fedex-gif1",
          ext: "gif"
        },
        7: {
          name: "fedex-gif2",
          ext: "gif"
        }
      },
      video: "fedex-video1",
      outro:
        'Ce projet a été permis grâce à une palpitante collaboration entre Google, BBDO New-york et nous-même à Mediamonks. Merci à <a href="https://www.linkedin.com/in/liva-grinberga-303b4120/" target="_blank">Liva Grinberga</a> pour ce remarquable travail graphique (Lead UI), et <a href="https://www.linkedin.com/in/matthijs-klip-b285552a/" target="_blank">Matthijs Klip</a> (Data Creative) pour ces riches moments de partage.',
      nextToPath: "kinder",
      nextToName: "Kinder (Site vitrine, monde)"
    }
  },
  {
    path: "/kinder",
    component: () => import("../views/design.vue"),
    meta: {
      title: "Paul Jobard ➡ Kinder.com",
      key: 5
    },
    props: {
      h1: "UX Designer <b>&</b> Créatif Assistant <b>pour</b> Ferrero",
      h2: {
        job: "(<b>UX</b>&<b>Créa</b>)",
        feat: "Mediamonks",
        name: "<b>Kinder.com</b>",
        descr: "(Site vitrine, monde)"
      },
      color: {
        backgroundColor: "#FF4801"
      },
      intro:
        "Depuis plus de 50 ans, <b>Ferrero</b> mise sur des valeurs humaines et familiales. Aujourd'hui, notre planète traverse une vraie épreuve, et Ferrero en a bien conscience, c'est pourquoi ils s'efforcent maintenant d'oeuvrer pour ce combat écologique et environnemental. À Mediamonks, nous nous sommes efforcés de respecter leur valeurs premières et retranscrire du mieux possible leurs nouvelles priorités. L'enjeux n'en était pas des moindres sur un projet d'une tel ampleur, le site (vitrine) <b>Kinder.com</b> touche 55 pays répartis aux quatres coins du globe.",
      imgs: {
        0: {
          name: "kinder-img1",
          ext: "png"
        }
      },
      video: "kinder-video1",
      outro:
        'Un grand merci à Ferrero pour les cartons de chocolats envoyés tout au long de la production, nous ne pouvions espérer mieux durant ce long hiver aux Pays-bas. Également, une mention très spéciale pour mes proches amis et partenaires <a href="https://www.linkedin.com/in/liva-grinberga-303b4120/" target="_blank">Liva Grinberga</a> (UI Lead), <a href="https://www.linkedin.com/in/jalmeida4/" target="_blank">João de Almeida</a> (UI Designer) & <a href="https://www.linkedin.com/in/daniel-sanchez-493a9485/" target="_blank">Daniel Sanchez</a> (UX Lead) sans qui cette expérience n\'aurait pas été la même.',
      nextToPath: "heinekenthesub",
      nextToName: "Heineken the Sub"
    }
  },
  {
    path: "/heinekenthesub",
    component: () => import("../views/design.vue"),
    meta: {
      title: "Paul Jobard ➡ Heineken the Sub",
      key: 6
    },
    props: {
      h1: "UX Designer <b>&</b> UX Content Strategist <b>pour</b> Heineken",
      h2: {
        job: "(<b>UX</b>)",
        feat: "Mediamonks",
        name: "<b>Heineken the Sub</b>",
        descr: "(site e-commerce, EU)"
      },
      color: {
        backgroundColor: "#008644"
      },
      intro:
        "Sur cette plateforme e-commerce bien dorée pour ne dire blonde, les gens peuvent faire deux des choses les plus importantes dans la vie : s'acheter des bières et découvrir le nouveau système de pression à domicile. En plus de pouvoir acheter la machine et ses recharges, le site apprend aux visiteurs comment servir la parfaite pression à la maison. Chez Mediamonks, nous avons produit le site dans son intègralité, du développement à la création d'un contenu très spécifique, incluant les vidéos et campagnes de communication connectées aux pages de promotions, <i>design</i>ées elles-même pour être en perpétuelle évolution.",
      imgs: {
        0: {
          name: "heinekenthesub-img1",
          ext: "png"
        },
        1: {
          name: "heinekenthesub-img2",
          ext: "png"
        }
      },
      outro:
        'Un grand merci à Heineken pour les livraisons de bières, le <a href="https://ishetalbiertijd.nl/" target="_blank"><i>Biertijd</i></a> n\'a jamais été aussi festif. Merci à l\'équipe de Mediamonks pour la mise en production d\'une si belle plateforme, notamment à Damian (UI Designer) et <a href="https://www.linkedin.com/in/petervanlanschot/" target="_blank">Peter Van Lanschot</a> (UX Lead).',
      nextToPath: "frico",
      nextToName: "Frico"
    }
  },
  {
    path: "/frico",
    component: () => import("../views/design.vue"),
    meta: {
      title: "Paul Jobard ➡ Frico.com",
      key: 7
    },
    props: {
      h1: "UX Designer <b>pour</b> Frico",
      h2: {
        job: "(<b>UX</b>)",
        feat: "Mediamonks",
        name: "<b>Frico</b>",
        descr: "(site vitrine, NL)"
      },
      color: {
        backgroundColor: "#FECE09"
      },
      intro:
        "Nous avons beau être les rois du fromage en Savoie, il faut être honnête que les hollandais sont des artistes en matière de Gouda. Et leur règne est véritablement indétronable, surtout depuis que nous avons mis en ligne une nouvelle version du site européen de Frico, l’un des producteurs majeurs du pays. En se plongeant dedans, on pourrait presque sentir l’odeur des centaines de variantes différentes de Gouda, à en perdre la tête, mais qui sommes-nous pour juger. Profitons-en plutôt!",
      imgs: {
        0: {
          name: "frico-img1",
          ext: "png"
        },
        1: {
          name: "frico-img2",
          ext: "png"
        },
        2: {
          name: "frico-img3",
          ext: "png"
        },
        3: {
          name: "frico-img4",
          ext: "png"
        },
        4: {
          name: "frico-img5",
          ext: "png"
        }
      },
      outro:
        'Une chose est sure, ils sont fiers de leurs fromages, à en découvrir le nombre de photos mis à disposition pour cette refonte, ce qui a fait le bonheur de nos UI Designers <a href="https://www.linkedin.com/in/skapitonov/" target="_blank">Sergii Kapitonov</a> et <a href="https://www.linkedin.com/in/luukvermeyden/" target="_blank">Luuk Vermeyden</a>. Comme toujours avec ces grands messieurs, un énorme merci pour le temps partagé ensemble.',
      nextToPath: "adidas",
      nextToName: "Adidas"
    }
  },
  {
    path: "/adidas",
    component: () => import("../views/design.vue"),
    meta: {
      title: "Paul Jobard ➡ Adidas Intranet",
      key: 8
    },
    props: {
      h1: "UX Designer <b>pour</b> Adidas",
      h2: {
        job: "(<b>UX</b>)",
        feat: "Mediamonks",
        name: "<b>Adidas</b>",
        descr: "(Intranet, EU)"
      },
      color: {
        backgroundColor: "#0D0D0D"
      },
      intro:
        "On ne compte plus le nombre de produits qu’Adidas a commercialisé; ce qui fait le bonheur des uns, fais le malheur des autres. Quel calvaire pour l'équipe marketing d'Adi Dassler de retrouver et organiser toutes ces références, comprendre les relations les unes entre les autres et leurs connexions selon les campagnes, saisons et sponsorings. C’est pourquoi, chez Mediamonks, nous leur avons conçu une interface intelligente permettant de <i>manager</i> efficacement le tout et rendre leurs journées bien plus confortables.",
      imgs: {
        0: {
          name: "adidas-img1",
          ext: "png"
        },
        1: {
          name: "adidas-img2",
          ext: "png"
        }
      },
      outro:
        'Si il ne fallait citer qu\'une personne, un grand merci à mon chef de projet <a href="https://www.linkedin.com/in/nawidfarhadi/" target="_blank">Nawid Farhadi</a> qui a su me soulager comme jamais dans cet océan de datas, et m\'épargner par la même occasion de nombreux maux de tête.',
      nextToPath: "araymond",
      nextToName: "Jeu de Cartes UX"
    }
  },
  {
    path: "/jeudecartesux",
    component: () => import("../views/design.vue"),
    meta: {
      title: "Paul Jobard ➡ Jeu de Cartes UX",
      key: 9
    },
    props: {
      h1: "Facilitator <b>&</b> Designer <b>pour</b> Workshops",
      h2: {
        job: "(<b>Facilitator</b>&<b>Designer</b>)",
        feat: "Vous",
        name: "<b>Succès</b>",
        descr: "(digital)"
      },
      color: {
        backgroundColor: "#0E0D0D"
      },
      intro:
        "\"Les français sont toujours en retard\", voilà un bien beau cliché, que nous entretenons malheureusement dans le domaine du digital. En matière d’UX, nous sommes bien en retard face à l’évolution mondiale, et avons un réel besoin d’éducation. Nous parlons de VX dans différentes villes européennes quand il faut encore définir l’UX chez nous. En tant que Designer, c’est une problématique que j’ai prise très aux sérieux au sein de mon environnement professionnel. Pour l’occasion, j’ai conçu un jeu de cartes permettant de comprendre les différentes tâches qu’un UX Designer est amené à effectuer pour le bien d’un projet, que ce soit en matière d’analyse ou de conception.",
      imgs: {
        0: {
          name: "jeudecartesux-img1",
          ext: "png"
        },
        1: {
          name: "jeudecartesux-img2",
          ext: "png"
        }
      },
      outro:
        "Le jeu de cartes est sujet à être utilisé dans différentes situations; lors d’une discussion avec un prospect afin de l’accompagner et être complètement transparent en matière d’UX, lors d’un kick-off afin de s’assurer que l’ensemble des équipes intervenantes soient en accord avec les besoins UX, avec un collègue pour le former sur les méthodologies et approches en UX Design, et bien d’autres cas...",
      nextToPath: "araymond",
      nextToName: "Raybond CRM"
    }
  },
  {
    path: "/araymond",
    component: () => import("../views/design.vue"),
    meta: {
      title: "Paul Jobard ➡ Raybond CRM",
      key: 10
    },
    props: {
      h1: "UX & UI Designer <b>pour</b> Araymond (Raybond)",
      h2: {
        job: "(<b>UX</b>&<b>UI</b>)",
        feat: "Adneom",
        name: "<b>Raybond</b>",
        descr: "(CRM, FR)"
      },
      color: {
        backgroundColor: "#05223F"
      },
      intro:
        "Araymond est aujourd’hui l’une des plus grosse société industrielle française à commandite simple, exerçant également à l’international. Qu’est-ce que c’est ? Que ce soit dans le domaine automobile, agro-industriel ou médical, ce sont eux qui réalisent l’immense majorité des pièces permettant aux mécaniques de fonctionner. À l’image de leur métier, un nouveau CRM a été développé pour huiler leurs mécaniques internes, et renforcer leurs processus de production. En exclusivité, voici deux directions artistiques d’UI basées sur une seule et même UX.",
      imgs: {
        0: {
          name: "araymond-img1",
          ext: "png"
        },
        1: {
          name: "araymond-img2",
          ext: "png"
        },
        2: {
          name: "araymond-img3",
          ext: "png"
        },
        3: {
          name: "araymond-img4",
          ext: "png"
        },
        4: {
          name: "araymond-img5",
          ext: "png"
        },
        5: {
          name: "araymond-img6",
          ext: "png"
        },
        6: {
          name: "araymond-img7",
          ext: "png"
        },
        7: {
          name: "araymond-img8",
          ext: "png"
        }
      },
      outro:
        "De telle société implique toujours des conseils d’administration et des processus de validation à rallonge. L’objectif en présentant ces visuels est de mettre en lumière la possibilité de jouer entre proposition arty et proposition classique, dans le but d’éveiller et stimuler l’intérêt des intervenants.",
      nextToPath: "tablerondefrancaise",
      nextToName: "La Table Ronde Française"
    }
  },
  {
    path: "/tablerondefrancaise",
    component: () => import("../views/design.vue"),
    meta: {
      title: "Paul Jobard ➡ AO La Table Ronde Française",
      key: 11
    },
    props: {
      h1: "UX & UI Designer <b>pour</b> La Table Ronde",
      h2: {
        job: "(<b>UX</b>&<b>UI</b>)",
        feat: "Adneom",
        name: "<b>La Table Ronde</b>",
        descr: "(Vitrine, FR)"
      },
      color: {
        backgroundColor: "#131415"
      },
      intro:
        "La réponse à l’appel d’offre pour la Table Ronde Française est le moment pour moi de vous présenter le résultat de deux jours de travail lancés à partir d'un simple brief .pdf. La réactivité et la capacité à savoir rebondir est, selon moi, le B.A-BA et le quotidien d’un designer. Il est capital d’entretenir et entraîner cette compétence, elle saura vous le rendre au moment voulu et réduire le stress que peut exercer notre métier. Voici la création de l’UX et de l’UI de deux sections importantes du site internet de cette association.",
      imgs: {
        0: {
          name: "trf-img1",
          ext: "png"
        },
        1: {
          name: "trf-img2",
          ext: "png"
        }
      },
      outro:
        "Lors de la création de ces visuels, aussi restreint que le temps pu être, il aura fallu établir une compréhension précise du sujet (du client et de son public), élaborer une architecture viable du contenu et concevoir l’UX et l’UI de pages clés.",
      nextToPath: "opalines",
      nextToName: "Les Opalines"
    }
  },
  {
    path: "/opalines",
    component: () => import("../views/design.vue"),
    meta: {
      title: "Paul Jobard ➡ AO Les Opalines",
      key: 12
    },
    props: {
      h1: "UX & UI Designer <b>pour</b> Les Opalines",
      h2: {
        job: "(<b>UX</b>&<b>UI</b>)",
        feat: "Adneom",
        name: "<b>Les Opalines</b>",
        descr: "(Intranet/CRM, FR)"
      },
      color: {
        backgroundColor: "#070B1F"
      },
      intro:
        "Vous en êtes arrivé là, vous avez bien pris le temps de visualiser tous les projets précédents ? Mon dieu, quelle ténacité ! À l’image de la Table Ronde Française, voici quelques visuelles réalisés en une journée pour un CRM de gestion de commande et de livraison de nourriture à domicile. Je le répète, il faut entraîner et cultiver notre créativité. Le monde change en permanence, et nous n’avons pas le temps vivre sur nos acquis, il faut en permanence s’adapter et évoluer avec. C'est d'ailleurs bien plus intéressant!",
      imgs: {
        0: {
          name: "opalines-img1",
          ext: "png"
        },
        1: {
          name: "opalines-img2",
          ext: "png"
        }
      },
      outro:
        "Un grand merci pour avoir pris le temps de parcourir l’intégralité de mes projets, et si ce n’est pas le cas, je vous invite vivement à visualiser les projets en haut de liste. C’est en quelques sortes les collaborations qui me rendent le plus fier.",
      nextToPath: "projets",
      nextToName: "Liste des Projets"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 400);
    });
  }
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
